module.exports = __webpack_public_path__ + "static/img/company-leadership-hero-lores.0f88edd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/company-leadership-hero-lores.jpg
// module id = 7fYC
// module chunks = 0